<div class="container-fluid content-box">
    <div class="row">
        <div class="col-2">
            <div class="card side-menu">
                <div class="card-header">
                    Dashboard                    
                </div>
                <div class="card-body">
                    <ul class="dasboard-menu">
                        <li><a (click)="navigate('university/resources')" [ngClass]="{'selected': router.url.includes('resources')}">Digital Resources</a></li>
                        <li><a (click)="navigate('university/webinars')" [ngClass]="{'selected': router.url.includes('webinars')}">Webinars</a></li>
                        <li><a (click)="navigate('university/blogs')" [ngClass]="{'selected': router.url.includes('blogs')}">Blogs</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
